/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Logo from '../../images/logo.svg';
import { Footer } from '@g17eco/molecules/footer';
import * as auth from '../../actions/auth';
import ActivationRequired from '../onboarding/forms/ActivationRequired';
import { RootState } from '../../reducers';
import { GenericState } from '../../slice/slice';
import './styles.scss';

interface NotActivatedProps {
  currentUser: GenericState<{
    firstName?: string,
    surname?: string
  }>;
  handleLogout: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

class NotActivated extends Component<NotActivatedProps> {

  render() {
    return (
      <div className='notActivatedWrapper'>
        <div className='notActivatedContainer'>
          <header>
            <img className='logo' src={Logo} alt='G17Eco' />
          </header>

          <div className='notActivatedBodyContainer'>
            {this.renderLoggedInMessage()}
            <ActivationRequired title='Thanks for signing up' />
          </div>
          <Footer />
        </div>
      </div>
    )
  }

  renderLoggedInMessage() {
    const { currentUser, handleLogout } = this.props;
    if (!currentUser.loaded) {
      return;
    }
    const user = currentUser.data;
    return <div className='row'>
      <div className='col offset-md-2 col-md-8 logged-in-message'>
        <p>You are currently logged in as <strong>{user.firstName} {user.surname}</strong>.
          To use a different user<Button color='link' size='sm' className='ml-1 p-0' onClick={handleLogout}>click here</Button>.
        </p>
      </div>
    </div>;
  }
}

const mapStateToProps = (state: RootState) => ({
  currentUser: state.currentUser,
});

const mapDispatchToProps = (dispatch: (p: any) => void) => ({
  handleLogout: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    dispatch(auth.logout())
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NotActivated);
